import React from 'react'
import {connect} from 'react-redux';
import CustomerModel from '/app/src/model/Customer/model';
import ConversationSelector from '/app/src/model/Conversation/selector';
import CustomerSelector from '/app/src/model/Customer/selector';
import EmployeesSelector from '/app/src/model/Employee/selector';
import TabIcon from '../TabIcon'
import AssignedOverview from '../Assigned/Overview';
import AssignedPrevious from '../Assigned/Previous';
import {Tabs} from '/app/src/component'

class UnassignedOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: 0
        }
        this.onTabClick = this.onTabClick.bind(this);
    }

    onTabClick(index) {
        this.setState({
            selectedIndex: index
        })

        // we should get all the tickets for this
        if(index === 1){
            const customer = this.props.customer;
            if(!customer.getIn(['tickets', 'fetched']) && !customer.getIn(['tickets', 'fetching'])){
                this.props.dispatch(CustomerModel.readResolvedTicketsFromDB(CustomerSelector.getId(customer)));
            }
        }
    }

    componentWillReceiveProps(nextProps){
        const conversation = this.props.conversation;
        const nextConversation = nextProps.conversation;

        const customerId = conversation.getIn(['info', 'customer_id']);
        const nextCustomerId = nextConversation.getIn(['info', 'customer_id']);

        if(customerId !== nextCustomerId){
            this.setState({
                selectedIndex: 0
            })
        }

    }

    render(){
        const customer = this.props.customer;
        const selectedIndex = this.state.selectedIndex;

        if(!customer)
            return <div> {'Kunden ej funnen.'} </div>;

        let tab0H = <TabIcon svgSrc='/images/Customer_S.svg' active={selectedIndex} index={0} onClick={this.onTabClick}/>
        let tab1H = <TabIcon svgSrc='/images/Menu_History_S.svg' active={selectedIndex} index={1} onClick={this.onTabClick}/>
        let tab0 = <AssignedOverview customer={customer}/>
        let tab1 = <AssignedPrevious customer={customer}/>

        return (
            <Tabs
                active={this.state.selectedIndex}
                header={[tab0H, tab1H]}
                body={[tab0, tab1]}
            />

        );
    }

}


function mapStateToProps(state, ownProps) {
    const room = ownProps.room;
    const currentConversation = ConversationSelector.getByRoom(state, room);
    const customerId = ConversationSelector.getCustomerId(currentConversation);
    const customer = CustomerSelector.getById(state, customerId)
    const onlineCoworkers = EmployeesSelector.getOnlineCoworkers(state);
    return {
        conversation: currentConversation,
        customer: customer,
        onlineCoworkers: onlineCoworkers,
        room: room
    };
}
export default connect(mapStateToProps, null)(UnassignedOptions);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Conversation/Unassigned/index.js